import { AppPage } from 'common/Layout';
import { ProductionCalendar } from 'features/production-calendar';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Производственный календарь',
    url: '',
  },
];

export const ProductionCalendarPage = () => {
  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
      }}
      documentTitle="Производственный календарь"
    >
      <ProductionCalendar />
    </AppPage>
  );
};
